export const RESULTS_URL_FRAGMENT = '/results';
export const TRACKS_URL_FRAGMENT = '/tracks';
export const LESSONS_URL_FRAGMENT = '/lessons';
export const TRACK_INTRO_URL_FRAGMENT = 'intro';
export const TRACK_EXAM_URL_FRAGMENT = 'exam';
export const TRACK_COMPLETE_URL_FRAGMENT = 'complete';
export const TRACK_RECOMMENDATIONS_URL_FRAGMENT = 'recommendations';
export const TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT = 'next-in-playlist';
export const TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT = 'playlist-complete';
export const TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT = 'playlist-incomplete';
export const PARTNER_TRACKS_URL_FRAGMENT = '/partners';
export const FAVORITES_URL_FRAGMENT = '/favorites';
export const SAVED_ITEMS_URL_FRAGMENT = '/saved-items';
export const WATCH_LATER_URL_FRAGMENT = `${SAVED_ITEMS_URL_FRAGMENT}/watch-later`;
export const MY_PLAYLISTS_URL_FRAGMENT = `${SAVED_ITEMS_URL_FRAGMENT}/playlists`;
export const CREATE_PLAYLIST_URL_FRAGMENT = `/create-playlist`;
export const EDIT_PLAYLIST_URL_FRAGMENT = `/edit-playlist`;
export const DUPLICATE_PLAYLIST_URL_FRAGMENT = `/duplicate-playlist`;
export const PLAYLIST_URL_FRAGMENT = `${MY_PLAYLISTS_URL_FRAGMENT}/:playlistId`;
export const PLAYLIST_RESULTS_URL_FRAGMENT = `${PLAYLIST_URL_FRAGMENT}${RESULTS_URL_FRAGMENT}`;
export const PRACTICAL_EXERCISE_URL_FRAGMENT = '/practical-exercise';
export const WIZARD_URL_FRAGMENT = '/wizard';
export const COURSE_OVERVIEW_URL_FRAGMENT = '/course-overview';
export const LESSON_OVERVIEW_URL_FRAGMENT = '/lesson-overview';
export const SHORT_OVERVIEW_URL_FRAGMENT_PREFIX = '/short-overview';
export const SHORT_OVERVIEW_URL_FRAGMENT = `${SHORT_OVERVIEW_URL_FRAGMENT_PREFIX}/:shortId/:source/:language`;
export const PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT = `${PLAYLIST_URL_FRAGMENT}/assignments/:portalId`;
export const ASSIGN_PLAYLIST_URL_FRAGMENT = `${PLAYLIST_URL_FRAGMENT}/assign-playlist/:portalId?`;
export const MYLEARNING_URL_FRAGMENT = '/mylearning';
export const AWARD_URL_FRAGMENT = '/award/:trackId';
export const SHARE_AWARD_URL_FRAGMENT = '/award-share/:trackId';
export const SHARE_AWARD_PREVIEW_URL_FRAGMENT = '/award-share/:trackId/achievement-preview';
export const LEGACY_AWARD_URL_FRAGMENT = '/award/:trackId/:awardName';
export const LEGACY_SHARE_AWARD_URL_FRAGMENT = '/award-share/:trackId/:awardName';
export const SHORT_URL_FRAGMENT = '/shortvideo';
export const PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS = [TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT];
export const SHORT_CONTENT_URL_FRAGMENT = `${SHORT_URL_FRAGMENT}/:shortId/:language/:playlistNavigation(${PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS.join('|')})?`;
export const PAGE_NAMES = {
  COURSE: 'course-page',
  LESSON: 'lesson-page',
  AWARD_SHARE: 'award-share-page',
  CATALOG: 'catalog-page',
  PARTNER: 'partner-page',
  TEAM: 'my-team-page',
  MY_LEARNING: 'my-learning-page',
  SAVED_ITEMS: 'my-saved-items-page',
  PLAYLISTS: 'my-playlists-page',
  CREATE_PLAYLIST: 'create-playlist-page',
  WIZARD: 'wizard-page',
  SHORT_CONTENT: 'short-content-page'
};